export function spaceInNumber(value: number | string, distance: number = 3) {
  return value
    .toString()
    .replace(new RegExp(`(\\d)(?=(\\d{${distance}})+(?!\\d))`, "g"), "$1 ");
}
